let defaultUserType = Number(3);
try {
    if (localStorage.user_type) {
        defaultUserType = Number(localStorage.user_type)
    }
} catch (e) {
    window.console.log(e)
}

let defaultIsOperater = Number(0);
try {
    if (localStorage.is_operater) {
        defaultIsOperater = Number(localStorage.is_operater)
    }
} catch (e) {
    window.console.log(e)
}

let defaultEpOrderTab = '3';
try {
    if (localStorage.epOrderTab) {
        defaultEpOrderTab = localStorage.epOrderTab
    }
} catch (e) {
    window.console.log(e)
}

let defaultDarenOrderTab = '3';
try {
    if (localStorage.darenOrderTab) {
        defaultDarenOrderTab = localStorage.darenOrderTab
    }
} catch (e) {
    window.console.log(e)
}

// export default {
//     code: localStorage.code,
//     openid: localStorage.openid,
//     unionid: localStorage.unionid,
//     auth_token: localStorage.auth_token, //认证信息
//     user_type: defaultUserType, //0-企业 1-达人 3-游客
//     is_operater: defaultIsOperater, //0-不是运营者 1-是运营者
//     user_id: localStorage.user_id, //用户id,达人和企业才显示
//     is_auth: Number(localStorage.is_auth), //0-未认证 1-已认证 2-已拒绝
//     is_pass: Number(localStorage.is_pass), //0-审核中 1-已审核 2-已拒绝
//     auth_type: Number(localStorage.auth_type), //0-未培训 1-线上培训 2-线下培训
//     rank: Number(localStorage.rank), //0-未开通 1-已开通
//     newbie_task: Number(localStorage.newbie_task), //0-未完成新手任务 1-已完成新手任务
//     is_agent: Number(localStorage.is_agent), //0-不是站长 1-是站长
//     isAnswer: Number(localStorage.isAnswer), //已答题
//     isInfo: Number(localStorage.isInfo), //达人已填信息
//     getTime: localStorage.getTime,
//     weChatNumber: String(localStorage.weChatNumber),
//     weChatFriendNum: String(localStorage.weChatFriendNum),
//     source: String(localStorage.source),
//     label: String(localStorage.label),
//     is_official: Number(localStorage.is_official),
//     mobileCon:'',
//     mobileTit:'',
//     isLogin:null,
//     templatePic: '',
//     previewImage: '',
//     siteName:'小城达人',
//     companyName: '梅州市艺博网络科技有限公司',
//     cityTel: '',
//     city:'梅州',
//     codeAddress: '',
//     siteName:'小城达人',
//     companyName: '梅州市艺博网络科技有限公司',
//     cityTel: '0753-2354999 19128188497',
//     city:'梅州',
//     codeAddress: 'https://img.xiaochengdaren.com/2019121710891.jpg',
//     icp:'粤ICP备19055270号',
//     epServicePic:'https://img.xiaochengdaren.com/2020031817074997006.jpg',
//     epServiceText:'企业助手',
//     darenServicePic:'https://img.xiaochengdaren.com/2020031817080350486.jpg',
//     darenServiceText:'达人管家',
// }

export default {
    code: localStorage.code,
    openid: localStorage.openid,
    unionid: localStorage.unionid,
    auth_token: localStorage.auth_token, //认证信息
    user_type: defaultUserType, //0-企业 1-达人 3-游客
    is_operater: defaultIsOperater, //0-不是运营者 1-是运营者
    user_id: localStorage.user_id, //用户id,达人和企业才显示
    is_auth: Number(localStorage.is_auth), //0-未认证 1-已认证 2-已拒绝
    is_pass: Number(localStorage.is_pass), //0-审核中 1-已审核 2-已拒绝
    auth_type: Number(localStorage.auth_type), //0-未培训 1-线上培训 2-线下培训
    rank: Number(localStorage.rank), //0-未开通 1-已开通
    newbie_task: Number(localStorage.newbie_task), //0-未完成新手任务 1-已完成新手任务
    is_agent: Number(localStorage.is_agent), //0-不是站长 1-是站长
    isAnswer: Number(localStorage.isAnswer), //已答题
    isInfo: Number(localStorage.isInfo), //达人已填信息
    getTime: localStorage.getTime,
    weChatNumber: String(localStorage.weChatNumber),
    weChatFriendNum: String(localStorage.weChatFriendNum),
    source: String(localStorage.source),
    label: String(localStorage.label),
    is_official: Number(localStorage.is_official),
    mobileCon:'',
    mobileTit:'',
    isLogin:null,
    templatePic: '',
    previewImage: '',
    epOrderTab: defaultEpOrderTab,
    darenOrderTab: defaultDarenOrderTab,
    siteName:'小城达人',
    companyName: '梅州市艺博网络科技有限公司',
    cityTel: '0753-2354999 19128188497',
    city:'梅州',
    codeAddress: 'https://img.xiaochengdaren.com/2019121710891.jpg',
    icp:'粤ICP备19055270号',
    epServicePic:'https://img.xiaochengdaren.com/2020031817074997006.jpg',
    epServiceText:'企业助手',
    darenServicePic:'https://img.xiaochengdaren.com/2020031817080350486.jpg',
    darenServiceText:'达人管家',
}
